import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { DisplayCustomCodeTaxCodeFragmentDoc } from './DisplayCustomCodeTaxCode.generated'
import * as Types from './purchasePlus_graphql'

export const UpdateCustomCodeDefaultTaxCodeFragmentDoc = gql`
  fragment UpdateCustomCodeDefaultTaxCode on TaxCode {
    id
    ...DisplayCustomCodeTaxCode
  }
  ${DisplayCustomCodeTaxCodeFragmentDoc}
` as unknown as DocumentNode<Types.UpdateCustomCodeDefaultTaxCodeFragment, unknown>
